/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum LengthUnit {
    METERS = 'meters',
    FEET = 'feet'
}


export function instanceOfLengthUnit(value: any): boolean {
    for (const key in LengthUnit) {
        if (Object.prototype.hasOwnProperty.call(LengthUnit, key)) {
            if (LengthUnit[key as keyof typeof LengthUnit] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LengthUnitFromJSON(json: any): LengthUnit {
    return LengthUnitFromJSONTyped(json, false);
}

export function LengthUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): LengthUnit {
    return json as LengthUnit;
}

export function LengthUnitToJSON(value?: LengthUnit | null): any {
    return value as any;
}

export function LengthUnitToJSONTyped(value: any, ignoreDiscriminator: boolean): LengthUnit {
    return value as LengthUnit;
}

